import { HttpMethod, Type } from "@/Utils/request/types";

export interface SaasPlan {
  code: string;
  name: string;
  tier: number;
  tagline: string;
  description: string;
  max_users: number | null;
  max_facilities: number | null;
  modules: string[];
  monthly_price: string;
  currency: string;
  trial_days: number;
}

export interface SaasClinicType {
  code: string;
  name: string;
  description: string;
  recommended_plan: string;
  departments: string[];
  locations: { name: string; beds: number }[];
  services: string[];
}

export interface SaasTenant {
  id: string;
  is_owner: boolean;
  name: string;
  slug: string;
  clinic_type: string;
  clinic_type_name: string;
  status: "trial" | "active" | "past_due" | "suspended" | "cancelled";
  trial_ends_at: string | null;
  trial_days_left: number | null;
  plan: SaasPlan;
  modules: string[];
  usage: { users: number; facilities: number };
  limits: { users: number | null; facilities: number | null };
  organization: string;
  first_facility: string | null;
}

export interface SaasSignupRequest {
  organization_name: string;
  clinic_type: string;
  plan: string;
  facility: {
    name: string;
    address: string;
    pincode: number;
    phone_number: string;
  };
  admin: {
    username: string;
    email: string;
    password: string;
    first_name: string;
    last_name: string;
    phone_number: string;
    gender: string;
  };
}

export interface SaasSignupResponse {
  tenant: SaasTenant;
  facility: { id: string; name: string };
  user: { username: string; id: string };
  access: string;
  refresh: string;
}

export default {
  plans: {
    path: "/api/v1/saas/plans/",
    method: HttpMethod.GET,
    noAuth: true,
    TRes: Type<{ results: SaasPlan[] }>(),
  },
  clinicTypes: {
    path: "/api/v1/saas/plans/clinic-types/",
    method: HttpMethod.GET,
    noAuth: true,
    TRes: Type<{ results: SaasClinicType[] }>(),
  },
  signup: {
    path: "/api/v1/saas/signup/",
    method: HttpMethod.POST,
    noAuth: true,
    TBody: Type<SaasSignupRequest>(),
    TRes: Type<SaasSignupResponse>(),
  },
  tenantMe: {
    path: "/api/v1/saas/tenant/me/",
    method: HttpMethod.GET,
    TRes: Type<SaasTenant | { tenant: null; modules: null }>(),
  },
  changePlan: {
    path: "/api/v1/saas/tenant/change_plan/",
    method: HttpMethod.POST,
    TBody: Type<{ plan: string }>(),
    TRes: Type<SaasTenant>(),
  },
} as const;
